export const checkWorkStatusIsWithoutCount = (workStatuses, checkedWorkStatusId) => {
  const checkedWorkStatus = workStatuses.find((status) => status.id === checkedWorkStatusId);
  return !!checkedWorkStatus && !!checkedWorkStatus.withoutCount;
};